import React from "react";
import get from "lodash/get";
import PropTypes from "prop-types";
import { SocialShare, Link } from "@quintype/components";
import { StoryCard } from "./../story-card";
import { StoryHeader } from "./../story-header";
import { StickySocialShareTemplate } from "./../sticky-social-share";
import RelatedStories from "./../related-stories";
import LatestMagazines from "./../latest-magazines";
import { StoryTags } from "../story-tags";
import { Instagram } from "../../atoms/icons/instagram";
import { Facebook } from "../../atoms/icons/facebook";
import { Linkedin } from "../../atoms/icons/linkedin";
import { Twitter } from "../../atoms/icons/twitter";
import { User } from "../../atoms/icons/user";
import humanizeDate from "../../utils/time-format";
import { TrendingNewsCarousel } from "../../trending-news-carousel";
import "./styles.m.css";
import { DfpAd } from "../../atoms/dfp-ad";
import fetch from "isomorphic-fetch";
import { changeHttpToHttps, storyShareClickHandler } from "../../utils/utils";
import { NextButton } from "../../atoms/icons/next-button";

export class BlankStoryTemplate extends React.Component {
  constructor() {
    super();
    this.state = {
      renderMetype: false,
      showTrendingStories: false,
      authorsData: []
    };
    this.generateCards = this.generateCards.bind(this);
  }
  componentDidMount() {
    this.setState({
      renderMetype: true,
      showTrendingStories: true
    });
    fetch(`/api/v1/authors`)
      .then(response => {
        return response.json();
      })
      .then(data => {
        this.setState({ authorsData: data.authors });
      });
  }

  generateCards() {
    return this.props.story.cards.map((card, index) => {
      return <StoryCard key={card.id + index} card={card} story={this.props.story} />;
    });
  }

  render() {
    const avatarUrl = get(this.props.story, ["authors", "0", "avatar-url"]);
    const color = get(this.props.story, ["sections", "0", "data", "color"], "#2F2BAD");
    const style = {
      "background-color": color
    };
    const style2 = {
      color: color
    };
    const firstSection = get(this.props.story, ["sections", "0"], []);
    const fulfillmentTrendingStories = get(this.props, ["trendingStories", "fulfillmentValue"], []);
    const trendingStories = fulfillmentTrendingStories.map(trendingStory => trendingStory.story);
    const authorName = get(this.props, ["story", "authors", "0", "name"], " ");
    const authorTwitter = get(this.props.story, ["authors", "0", "twitter-handle"], "");
    const authorId = this.props.story.authors[0].id;
    const storyAuthorDetails = this.state.authorsData
      ? this.state.authorsData.filter(authorData => authorData.id === authorId)
      : [];
    const authorInstagram = get(storyAuthorDetails[0], ["metadata", "instagram"], "");
    const authorLinkedIn = get(storyAuthorDetails[0], ["metadata", "linkedin"], "");
    const authorFacebook = get(storyAuthorDetails[0], ["metadata", "facebook"], "");
    const authorUrl = changeHttpToHttps(this.props.story.authors[0]["avatar-url"]);
    const currentSection = get(this.props, ["story", "sections", "0"], {});
    const publisherUrl = get(this.props, ["config", "sketches-host"], "https://www.sme10x.com");

    return (
      <div styleName="blank-story">
        {this.state.showTrendingStories &&
          trendingStories.length > 1 && <TrendingNewsCarousel stories={trendingStories} config={this.props.config} />}
        {currentSection.slug === "magissues" ? (
          <div styleName="breadcrumb-wrapper">
            <Link styleName="breadcrumb-link" href="https://www.sme10x.com">
              HOME
            </Link>
            <NextButton height={14} width={14} />
            <Link styleName="breadcrumb-link" href={`/${currentSection.slug}`}>
              {currentSection["display-name"]}
            </Link>
            <NextButton height={14} width={14} />
            <h1 styleName="story-title">{this.props.story.headline}</h1>
          </div>
        ) : (
          <StoryHeader story={this.props.story} config={this.props.config} />
        )}
        <div styleName="blank-story-body-wrap">
          <SocialShare
            template={StickySocialShareTemplate}
            title={this.props.story.headline}
            url={this.props.story.slug}
            hashtags={this.props.story && this.props.story.tags.map(tag => tag.name).toString()}
            color="#1c1c1c"
            sticky
            onClick={storyShareClickHandler(
              this.props.story["story-content-id"],
              `${publisherUrl}/${this.props.story.slug}`
            )}
          />
          <div styleName="blank-story-body">
            {currentSection.slug !== "magissues" && (
              <div styleName="author-section-container">
                <div styleName="author-container">
                  <div styleName="author-name">{authorName}</div>
                  <div styleName="social-icons">
                    {(authorTwitter || authorFacebook || (authorLinkedIn || authorInstagram)) && (
                      <span styleName="author-link">Connect With Me On</span>
                    )}
                    <div styleName="author-links">
                      {authorFacebook && (
                        <a styleName={`icon`} target="_blank" rel="noopener noreferrer" href={authorFacebook}>
                          <Facebook width="6" height="13" color="white" />
                        </a>
                      )}
                      {authorTwitter && (
                        <a
                          styleName={`icon`}
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`https://twitter.com/${authorTwitter}`}
                        >
                          <Twitter width="12" height="10" color="white" />
                        </a>
                      )}
                      {authorLinkedIn && (
                        <a styleName={`icon`} target="_blank" rel="noopener noreferrer" href={authorLinkedIn}>
                          <Linkedin width="13" height="10" color="white" />
                        </a>
                      )}
                      {authorInstagram && (
                        <a styleName={`icon`} target="_blank" rel="noopener noreferrer" href={authorInstagram}>
                          <Instagram width="11.4" height="11.4" color="white" />
                        </a>
                      )}
                    </div>
                  </div>
                  <div styleName="author-image">{avatarUrl ? <img src={authorUrl} /> : <User />}</div>
                  <div styleName="side-bleeding" />
                  <div styleName="pink-bleeding" />
                </div>
                {firstSection.name && (
                  <Link href={`/${firstSection.slug}`} styleName="section-name-container" style={style}>
                    {firstSection.name}
                  </Link>
                )}
              </div>
            )}
            {currentSection.slug !== "magissues" && (
              <div styleName="published-date">
                Published: <time>{humanizeDate(this.props.story["last-published-at"])}</time>
              </div>
            )}
            {currentSection.slug !== "magissues" &&
              this.props.story.headline && <h1 styleName="story-headline">{this.props.story.headline}</h1>}
            {currentSection.slug !== "magissues" &&
              this.props.story.subheadline && (
                <div styleName="story-subheadline" style={style2}>
                  {this.props.story.subheadline}
                </div>
              )}

            {this.generateCards()}

            <StoryTags tags={this.props.story.tags} color={color} />
          </div>
        </div>
        <div styleName="sponsored-bio-ad">
          <DfpAd adtype="StorySponsoredBio" />
        </div>
        {currentSection.slug !== "magissues" ? (
          <RelatedStories relatedStories={this.props.relatedStories} color={color} />
        ) : (
          <LatestMagazines relatedStories={this.props.relatedStories} color={color} />
        )}
      </div>
    );
  }
}

BlankStoryTemplate.propTypes = {
  story: PropTypes.object,
  config: PropTypes.object,
  relatedStories: PropTypes.array
};

function BlankStory({ story, relatedStories, config, trendingStories }) {
  return (
    <BlankStoryTemplate
      story={story}
      relatedStories={relatedStories}
      config={config}
      trendingStories={trendingStories}
    />
  );
}

BlankStory.propTypes = {
  story: PropTypes.object,
  relatedStories: PropTypes.array,
  config: PropTypes.object,
  trendingStories: PropTypes.array
};

export { BlankStory };
